















import InputField from "./InputField";
import Multiselect from "vue-multiselect";
import { Config } from "../../utils/Config";
import { ListParamApi } from "../../api/ListParamApi";
import { Option } from "../../models/Option";

export default {
    name: "JournalObjectSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
        value: Option,
        systemParamsOnly: Boolean,
    },
    data() {
        return {
            ListParamApi: new ListParamApi(),
            selected: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {
        let self = this;
        self.selected = self.value;

        self.ListParamApi.getAll({
            type: Option.EListParamType.journal_entry_object,
        }).then(function (res) {
            self.options = res;
            if (self.systemParamsOnly) {
                self.options = _.filter(self.options, {
                    available_for_notifications: true,
                });
                if (!_.find(self.options, { id: self.selected.id })) {
                    // if is not part of selectable values
                    self.selected = null;
                }
            }
        });
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
    },
};
